import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Language resources - can be expanded later
const resources = {
  en: {
    translation: {
      // Common translations
      "welcome": "Welcome",
      "dashboard": "Dashboard",
      "settings": "Settings",
      "language": "Language",
      "theme": "Theme",
      "save": "Save",
      "cancel": "Cancel",
      "loading": "Loading...",
      "success": "Success",
      "error": "Error",
      "required": "This field is required",
      "invalid_email": "Please enter a valid email address",
      "invalid_url": "Please enter a valid URL",
    }
  },
  ar: {
    translation: {
      "welcome": "مرحبا",
      "dashboard": "لوحة القيادة",
      "settings": "الإعدادات",
      "language": "اللغة",
      "theme": "المظهر",
      "save": "حفظ",
      "cancel": "إلغاء",
      "loading": "جاري التحميل...",
      "success": "نجح",
      "error": "خطأ",
      "required": "هذا الحقل مطلوب",
      "invalid_email": "يرجى إدخال عنوان بريد إلكتروني صحيح",
      "invalid_url": "يرجى إدخال رابط صحيح",
    }
  },
  fr: {
    translation: {
      "welcome": "Bienvenue",
      "dashboard": "Tableau de bord",
      "settings": "Paramètres",
      "language": "Langue",
      "theme": "Thème",
      "save": "Sauvegarder",
      "cancel": "Annuler",
      "loading": "Chargement...",
      "success": "Succès",
      "error": "Erreur",
      "required": "Ce champ est requis",
      "invalid_email": "Veuillez saisir une adresse email valide",
      "invalid_url": "Veuillez saisir une URL valide",
    }
  },
  es: {
    translation: {
      "welcome": "Bienvenido",
      "dashboard": "Panel de control",
      "settings": "Configuraciones",
      "language": "Idioma",
      "theme": "Tema",
      "save": "Guardar",
      "cancel": "Cancelar",
      "loading": "Cargando...",
      "success": "Éxito",
      "error": "Error",
      "required": "Este campo es requerido",
      "invalid_email": "Por favor ingrese una dirección de email válida",
      "invalid_url": "Por favor ingrese una URL válida",
    }
  },
  de: {
    translation: {
      "welcome": "Willkommen",
      "dashboard": "Dashboard",
      "settings": "Einstellungen",
      "language": "Sprache",
      "theme": "Theme",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "loading": "Laden...",
      "success": "Erfolgreich",
      "error": "Fehler",
      "required": "Dieses Feld ist erforderlich",
      "invalid_email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      "invalid_url": "Bitte geben Sie eine gültige URL ein",
    }
  }
};

i18n
  // Load translation using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,

    // Default language if detection fails
    fallbackLng: 'en',

    // Language detection options
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'querystring', 'cookie', 'subdomain'],

      // Cache user language in localStorage
      caches: ['localStorage'],

      // localStorage key
      lookupLocalStorage: 'i18nextLng',

      // Cookie options
      lookupCookie: 'i18nextLng',

      // Don't lookup language from path
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
    },

    // Backend options for loading translations from server
    backend: {
      // Path to load resources from
      loadPath: '/locales/{{lng}}/{{ns}}.json',

      // Allow loading from resources object as fallback
      allowMultiLoading: false,

      // Parse data after loading
      parse: (data: string) => JSON.parse(data),
    },

    debug: false, // Set to true for debugging

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // React options
    react: {
      // Trigger re-render when language changes
      bindI18n: 'languageChanged',

      // Trigger re-render when translations are loaded
      bindI18nStore: 'added removed',

      // Use suspense for loading translations
      useSuspense: false,
    },

    // Load language synchronously to avoid render issues
    initImmediate: false,
  });

// Handle RTL languages
const rtlLanguages = ['ar', 'he', 'fa', 'ur'];

i18n.on('languageChanged', (lng) => {
  // Update document direction based on language
  const isRtl = rtlLanguages.includes(lng);
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
});

export default i18n;